
const initCountProduct = () => {
  // ATTENTION : LE PARAMETRE "diff" EST OBSOLETE, REMPLACE PAR LES ATTRIBUTS MIN, MAX ET STEP
  function changeQuantity(btnEl, diff) {
    var inputEl = false;

    if( diff == '+' || diff == '-' ){
      inputEl = btnEl.parentNode.getElementsByClassName('input-count')[0];
    }else{
      inputEl = btnEl;
    }

    var step = parseInt( inputEl.getAttribute('step') );
    if( isNaN(step) ){
      step = 1;
    }
    var min = parseInt( inputEl.getAttribute('min') );
    if( isNaN(min) ){
      min = 1;
    }
    var max = parseInt( inputEl.getAttribute('max') );
    if( isNaN(max) ){
      max = 1;
    }

    var nextVal = 0;
    if( diff == '+' ){
      nextVal = parseInt(inputEl.value) + step;
    }else if( diff == '-' ){
      nextVal = parseInt(inputEl.value) - step;
    }else{
      nextVal = diff;
    }

    if( nextVal > max ){
      nextVal = max;
    };

    if( nextVal < min ){
      nextVal = min;
    }

    const event = new Event('change');
    inputEl.value = nextVal < 0 ? 0 : nextVal;
    inputEl.dispatchEvent(event);
  }

  const lessBtns = document.querySelectorAll('.less');
  const moreBtns = document.querySelectorAll('.more');
  const inputs = document.querySelectorAll('.input-count');

  inputs.forEach((input) => {
    input.addEventListener('input', (e) => {
      if (input.value < 0 || input.value === '-') input.value = 0;
      if (input.value > 0) input.value = input.value * 1;
    });
    input.addEventListener('keyup', (e) => {
      if (input.value < 0 || input.value === '-') input.value = 0;
      if (input.value > 0) input.value = input.value * 1;
      changeQuantity( e.target, input.value );
    });
    input.addEventListener('change', (e) => {
      if (input.value === '') input.value = 0;
    });
  });

  lessBtns.forEach((lessBtn) => {
    lessBtn.addEventListener('click', (e) => {
      changeQuantity(e.target, '-');
    });
  });

  moreBtns.forEach((moreBtn) => {
    moreBtn.addEventListener('click', (e) => {
      changeQuantity(e.target, '+');
    });
  });
};

export default initCountProduct;
